import get from "lodash/get";
import { useMemo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { createDomElement } from ".";
import { CART_ITEMS_PATH } from "../components/BookingForm/booking-form.helpers";
import { ERoute } from "./Routes";
export var CustomTitleRenderer = function (_a) {
    var _b;
    var componentType = _a.componentType, hasLoaded = _a.hasLoaded;
    var titleTag = document.querySelector("title");
    var titleString = useRef((titleTag === null || titleTag === void 0 ? void 0 : titleTag.innerText) || "");
    var pathname = useLocation().pathname;
    var t = useTranslation().t;
    var isRootEl = "WSROOT" === componentType;
    var isCartEl = ["WSCARTPREVIEWFLOATING", "WSCARTPREVIEW"].includes(componentType);
    var cartItems = useSelector(function (state) { return get(state, "cartReducer.cart_items", []); });
    var otherEl = !(isRootEl || isCartEl);
    // Get total quantity
    var cartItemsCount = useMemo(function () {
        var count = cartItems
            .reduce(function (items, form) { return items.concat(get(form, CART_ITEMS_PATH)); }, [])
            .reduce(function (total, item) { return total + +get(item, "position.quantity", 0); }, 0);
        return count;
    }, [JSON.stringify(cartItems)]);
    var routeTitleMap = (_b = {},
        _b[ERoute.BOOKCART] = t("page_titles.bookcart"),
        _b[ERoute.COURSES] = t("page_titles.courses"),
        _b[ERoute.SUCCESS] = t("page_titles.success"),
        _b[ERoute.PAYBOOK] = t("page_titles.paybook"),
        _b[ERoute.APPROVED] = t("page_titles.payment_approved"),
        _b[ERoute.CANCELLED] = t("page_titles.payment_cancelled"),
        _b[ERoute.CONSENTS] = t("page_titles.consents"),
        _b[ERoute.BANK_TRANSFER] = t("page_titles.banktransfer"),
        _b[ERoute.SEPA_DIRECT_DEBIT] = t("page_titles.sepadirectdebit"),
        _b[ERoute.CART] = t("page_titles.cart"),
        _b[ERoute.CHECKOUT] = t("page_titles.checkout"),
        _b);
    // Create new Title tag if one does not exist
    useEffect(function () {
        if (!hasLoaded || otherEl || titleTag)
            return;
        titleTag = createDomElement({ id: "", el: "title", html: "" });
        document.head.appendChild(titleTag);
    }, [hasLoaded, otherEl, titleTag]);
    // backup original title
    useEffect(function () {
        if (!hasLoaded || otherEl)
            return;
        if (titleTag && !titleTag.dataset.originalTitle) {
            titleTag.dataset.originalTitle = titleTag.innerText || "";
        }
    }, [hasLoaded, otherEl, titleTag]);
    useEffect(function () {
        if (!hasLoaded)
            return;
        var pageTitle = (isRootEl ? routeTitleMap[pathname] : titleTag === null || titleTag === void 0 ? void 0 : titleTag.dataset.originalTitle) || "";
        var prefix = isRootEl ? t("page_titles.prefix") : "";
        var postfix = isRootEl ? t("page_titles.postfix") : "";
        var titleWithoutCart = t("page_titles.title", { pageTitle: pageTitle, cartCount: "", prefix: prefix, postfix: postfix }).trim();
        var newTitle = t("page_titles.title", {
            pageTitle: pageTitle,
            prefix: prefix, postfix: postfix,
            cartCount: cartItemsCount === 0 ? "" : t('page_titles.cart_count', { count: cartItemsCount }),
        }).trim();
        titleString.current = newTitle;
        if (titleTag)
            titleTag.dataset.originalTitle = titleWithoutCart;
    }, [hasLoaded]);
    // set new title
    useEffect(function () {
        if (!titleTag || !hasLoaded || otherEl || !titleString.current)
            return;
        titleTag.innerText = titleString.current;
    }, [hasLoaded, otherEl, titleString.current]);
    return null;
};
